const PLACE_HOLDERS = [

    { name: "First Name ", text: "{{FName}}" },
    { name: "Last Name", text: "{{LName}}" },
    { name: "Street Address", text: "{{StreetAddress}}" },
    { name: "City", text: "{{City}}" },
    { name: "State", text: "{{State}}" },
    { name: "ZipCode", text: "{{ZipCode}}" },
    { name: "Phone", text: "{{Phone}}" },
    { name: "Email", text: "{{Email}}" },
    { name: "epoDate", text: "{{EPODate}}" },
    { name: "client Lo First Name", text: "{{SalesRepFName}}" },
    { name: "client Lo Last Name", text: "{{SalesRepLName}}" },
    { name: "client Lo Email", text: "{{SalesRepEmail}}" },
    { name: "client Lo Mobile", text: "{{SalesRepMobile}}" },
    { name: "client Lo Phone", text: "{{SalesRepPhone}}" },
    { name: "User Name", text: "{{UserName}}" },
    { name: "User First Name", text: "{{UserFName}}" },
    { name: "User Last Name", text: "{{UserLName}}" },
    { name: "User Email", text: "{{UserEmail}}" },
    { name: "User  Phone", text: "{{UserPhone}}" },
    { name: "Company Name", text: "{{CompanyName}}" },
    { name: "Company Legal Name", text: "{{CompanyLegalName}}" },
    { name: "Company Website", text: "{{CompanyWebsite}}" },
    { name: "Company Email", text: "{{CompanyEmail}}" },
    { name: "Company Phone", text: "{{CompanyPhone}}" },
    { name: "User Street Address", text: "{{UserStreetAddress}}" },
    { name: "User City", text: "{{UserCity}}" },
    { name: "User State", text: "{{UserState}}" },
    { name: "User ZipCode", text: "{{UserZipCode}}" },
    { name: "User NMLS", text: "{{UserNmls}}" },
    { name: "User Profile Picture", text: "{{UserProfilePicture}}" },
    { name: "MPOC Name", text: "{{MPOCName}}" },
    { name: "MPOC Email", text: "{{MPOCEmail}}" },
    { name: "MPOC  Phone", text: "{{MPOCPhone}}" },
    { name: "MPOC Street Address", text: "{{MPOCStreetAddress}}" },
    { name: "MPOC City", text: "{{MPOCCity}}" },
    { name: "MPOC State", text: "{{MPOCState}}" },
    { name: "MPOC ZipCode", text: "{{MPOCZipCode}}" },
    { name: "MPOC NMLS", text: "{{MPOCNmls}}" },
    { name: "Company NMLS", text: "{{CompanyNmls}}" },
    { name: "MPOC Profile Picture", text: "{{MPOCProfilePicture}}" },
    { name: "Current Date", text: "{{CurrentDate}}" },
    { name: "DOB", text: "{{DOB}}" },
    { name: "Closing Date", text: "{{ClosingDate}}" },
    { name: "Type Of Loan", text: "{{TypeOfLoan}}" },
    { name: "Calendar Link", text: "{{CalendarLink}}" },
];

const LEKSY_PLACE_HOLDERS = [
    {
        name: 'Contact',
        category: 'CONTACT',
        fields: [
            { name: "First Name ", value: "{{FName}}" },
            { name: "Last Name", value: "{{LName}}" },
            { name: "Street Address", value: "{{StreetAddress}}" },
            { name: "City", value: "{{City}}" },
            { name: "State", value: "{{State}}" },
            { name: "ZipCode", value: "{{ZipCode}}" },
            { name: "Phone", value: "{{Phone}}" },
            { name: "Email", value: "{{Email}}" },
            { name: "epoDate", value: "{{EPODate}}" },
            { name: "DOB", value: "{{DOB}}" },
            { name: "Closing Date", value: "{{ClosingDate}}" },
            { name: "Current Date", value: "{{CurrentDate}}" },
            { name: "Company NMLS", value: "{{CompanyNmls}}" },
            { name: "Type Of Loan", value: "{{TypeOfLoan}}" },
            { name: "Calendar Link", value: "{{CalendarLink}}" }
        ]
    },
    {
        name: "Client Lo",
        category: 'CLIENT_LO',
        fields: [{ name: "client Lo First Name", value: "{{SalesRepFName}}" },
        { name: "client Lo Last Name", value: "{{SalesRepLName}}" },
        { name: "client Lo Email", value: "{{SalesRepEmail}}" },
        { name: "client Lo Mobile", value: "{{SalesRepMobile}}" },
        { name: "client Lo Phone", value: "{{SalesRepPhone}}" }]
    },
    {
        name: 'User',
        category: 'USER',
        fields: [
            { name: "User Name", value: "{{UserName}}" },
            { name: "User First Name", value: "{{UserFName}}" },
            { name: "User Last Name", value: "{{UserLName}}" },
            { name: "User Email", value: "{{UserEmail}}" },
            { name: "User  Phone", value: "{{UserPhone}}" },
            { name: "User Street Address", value: "{{UserStreetAddress}}" },
            { name: "User City", value: "{{UserCity}}" },
            { name: "User State", value: "{{UserState}}" },
            { name: "User ZipCode", value: "{{UserZipCode}}" },
            { name: "User NMLS", value: "{{UserNmls}}" },
            { name: "User Profile Picture", value: "{{UserProfilePicture}}" }
        ]
    },
    {
        name: 'Company',
        category: 'COMPANY',
        fields: [
            { name: "Company Name", value: "{{CompanyName}}" },
            { name: "Company Legal Name", value: "{{CompanyLegalName}}" },
            { name: "Company Website", value: "{{CompanyWebsite}}" },
            { name: "Company Email", value: "{{CompanyEmail}}" },
            { name: "Company Phone", value: "{{CompanyPhone}}" }
        ]
    },
    {
        name: 'MPOC',
        category: 'MPOC',
        fields: [
            { name: "MPOC Name", value: "{{MPOCName}}" },
            { name: "MPOC Email", value: "{{MPOCEmail}}" },
            { name: "MPOC  Phone", value: "{{MPOCPhone}}" },
            { name: "MPOC Street Address", value: "{{MPOCStreetAddress}}" },
            { name: "MPOC City", value: "{{MPOCCity}}" },
            { name: "MPOC State", value: "{{MPOCState}}" },
            { name: "MPOC ZipCode", value: "{{MPOCZipCode}}" },
            { name: "MPOC NMLS", value: "{{MPOCNmls}}" },
            { name: "MPOC Profile Picture", value: "{{MPOCProfilePicture}}" }
        ]
    }
];

const TEMPLATE_CATEGORY = {
    GENERAL: 'G',
    AUTO_ALERT_RESPONSE: 'A',
    DOB: 'D',
    CLOSING_DATE: 'C'
}

const TAG_TYPE = {
    PRIVATE: 1,
    PUBLIC: 2.
}

const TAG_CATEGORY = {
    EMAIL: 1,
    SMS: 2,
    SEQUENCE: 3
}

export {
    LEKSY_PLACE_HOLDERS,
    TAG_CATEGORY,
    TAG_TYPE,
    TEMPLATE_CATEGORY,
    PLACE_HOLDERS
}